var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 22 22" }, props),
    React.createElement("defs", null),
    React.createElement(
      "title",
      null,
      "icon_qauser"
    ),
    React.createElement(
      "g",
      { id: "\u30EC\u30A4\u30E4\u30FC_2", "data-name": "\u30EC\u30A4\u30E4\u30FC 2" },
      React.createElement(
        "g",
        { id: "area_qadetail" },
        React.createElement(
          "g",
          { id: "item_icon" },
          React.createElement(
            "g",
            { id: "icon_qauser" },
            React.createElement(
              "g",
              { id: "base_icon" },
              React.createElement("circle", { id: "fig_cercle", className: styles["cls-1"] || "cls-1", cx: "11", cy: "11", r: "11" })
            ),
            React.createElement(
              "g",
              { id: "icon_user" },
              React.createElement("path", { id: "item_user1", className: styles["cls-2"] || "cls-2", d: "M8.15 7.54c0 2 1.27 4 2.84 4s2.83-2 2.83-4S12.55 4 11 4 8.15 5.59 8.15 7.54z" }),
              React.createElement("path", { id: "item_user2", className: styles["cls-2"] || "cls-2", d: "M11 8.57h1.72a4.59 4.59 0 0 0 .38 2.56 2.48 2.48 0 0 0 1.67 1.1c.93.29 1.18.57 2.54 1.13a2.19 2.19 0 0 1 1.21 1.26 2.44 2.44 0 0 1 .14 1.38H3.34a2.44 2.44 0 0 1 .14-1.38 2.19 2.19 0 0 1 1.21-1.26c1.36-.56 1.61-.84 2.54-1.13a2.48 2.48 0 0 0 1.67-1.1 4.59 4.59 0 0 0 .38-2.56z" })
            )
          )
        )
      )
    )
  );
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-svg-loader/lib/loader.js!./src/components/atoms/icon/images/qauser.svg
// module id = 1062
// module chunks = 0